import { NgModule } from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import { CommonModule } from '@angular/common';
import {AngularFireAuthGuard, AuthPipe, customClaims, redirectLoggedInTo} from "@angular/fire/compat/auth-guard";
import {pipe} from "rxjs";
import {map} from "rxjs/operators";
import {LoginModule} from "./login/login.module";

const loggedInAndVerified: AuthPipe = map(user => (!!user && user.emailVerified));
const passwordUpdated = pipe(customClaims, map(claims => claims.passwordUpdated));
const redirectTrueUnauthorizedTo = (redirect: any[]) => pipe(loggedInAndVerified, map(loggedIn => loggedIn || redirect));
const redirectPasswordNotUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => updated || redirect));
const redirectPasswordUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => !updated  || redirect));
const redirectUnauthorizedToLogin = () => redirectTrueUnauthorizedTo(['auth/login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['statement']);
const redirectToPasswordUpdate = () => redirectPasswordNotUpdatedTo(['auth']);
const redirectToStatement = () => redirectPasswordUpdatedTo(['statement']);
const nabelAdminOnly = () => pipe(customClaims, map(claims => claims.nabelAdmin ? true : ['statement']));
const customerAdminOnly = () => pipe(customClaims, map(claims => claims.customerAdmin?.length ? true : ['statement']));
const nabelOrCustomerAdmin = () => pipe(customClaims, map(claims => (claims.nabelAdmin || claims.customerAdmin?.length) ? true : ['statement']));

const routes: Routes = [
  {
    path: '',
    redirectTo: 'statement',
    pathMatch: 'full',
  },
  {
    path: 'statement',
    loadChildren: () => import('./statement/statement.module').then(m => m.StatementModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'member',
    loadChildren: () => import('./member/member.module').then(m => m.MemberModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'securitypolicy',
    loadChildren: () => import('./security-policy/security-policy.module').then(m => m.SecurityPolicyModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'privacypolicy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'auth',
    loadChildren: () => LoginModule,
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToStatement}
  },
  {path: '**', redirectTo: 'statement'},
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
